<!--
    校区管理-员工管理-购买账号
    功能：购买账号数量
    说明：版本3.0需求
-->
<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      title="购买作课上课上号数"
      width="650px"
    >
      <div class="content">
        <el-form
          ref="form"
          :rules="rules"
          :model="form"
          class="form">
          <el-form-item
            label="购买单价：">
            ￥199元/个
          </el-form-item>
          <el-form-item
            label="账号数量配置："
            prop="user_count">
            <el-input v-model="form.user_count"/>
          </el-form-item>
          <el-form-item
            label="购买总价：">
            <span class="pice">￥99999</span>
          </el-form-item>
        </el-form>
      </div>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          v-if="!isSuccess"
          :loading="loading"
          type="primary"
          @click="submitData()">确认去支付</el-button>
        <el-button
          v-else
          type="primary"
          @click="submitData()">完成支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs';

export default {
  name: 'SetAnnualFee',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    const validNum = (rule, value, callback) => {
      const reg = /^[1-9]\d*$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error('请输入正整数！'));
      }
    };
    return {
      loading: false,
      dateVal: null,
      isSuccess: false,
      form: { user_count: null },
      rules: {
        user_count: [
          { required: true, message: '请输入账号数', trigger: 'blur' },
          { validator: validNum, trigger: 'blur' },
        ],
      },
    };
  },
  mounted() {
    const now = dayjs().format('YYYY-MM-DD');
    const MM = dayjs().format('MM-DD');
    const YY = dayjs().year();
    this.dateVal = `${now} ~ ${YY + 1}-${MM}`;
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },
    submitData() {
      if (this.dateVal) {
        const starTime = this.dateVal[0];
        const endTime = this.dateVal[1];
        this.$http.patch(`/api/service/operate/clients/${this.item.id}/vip`, {
          vip_start_at: starTime,
          vip_end_at: endTime,
        }).then(() => {
          this.$emit('close-dialog');
          this.$emit('refresh-data');
          this.$message.success('年服务设置成功！');
        }).catch((err) => {
          this.$message.error(err.message);
        });
      } else {
        this.$message.warning('请选择年服务时间！');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content{
  padding: 0 10px;
}
.tip{
  height: 40px;
  line-height: 40px;
  background: #FFFBE6;
  border-radius: 4px;
  border: 1px solid #FFE58F;
  margin-bottom: 15px;
  padding: 0 30px;
  .icon{
    color: #FAAD14;
    font-size: 16px;
    margin-right: 10px;
  }
}
.item-row{
  padding-top: 15px;
}
.pice{
  font-size: 20px;
    color: red;
}
.dialog-footer{
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Staff/components/openLimit.vue